// src/crypto/kdf.ts
// KEK 派生（Argon2id） + 子密钥派生（HKDF-SHA256）。
import { argon2id } from "@noble/hashes/argon2";
import { hkdf } from "@noble/hashes/hkdf";
import { sha256 } from "@noble/hashes/sha256";
import { randomBytes } from "@noble/ciphers/webcrypto";
import { ARGON2, AEAD, INFO } from "./params";
/** 注册时生成新 salt；解锁时从 D1 拉。 */
export function newKdfSalt() {
    return randomBytes(16);
}
/** passphrase → 32B KEK（Argon2id）。CPU/内存敏感，调用后请记得 zeroize。 */
export async function deriveKEK(passphrase, kdfSalt) {
    const pwd = new TextEncoder().encode(passphrase);
    // @noble/hashes 的 argon2id：(password, salt, opts) → Uint8Array
    const out = argon2id(pwd, kdfSalt, {
        m: ARGON2.memoryKiB,
        t: ARGON2.iterations,
        p: ARGON2.parallelism,
        dkLen: ARGON2.outputLen,
    });
    pwd.fill(0);
    return out;
}
/** 子密钥派生：HKDF-SHA256(ikm=root_key, salt=∅, info, L=32) */
export function deriveSubKey(rootKey, info, outLen = AEAD.keyLen) {
    return hkdf(sha256, rootKey, new Uint8Array(0), info, outLen);
}
/** 便捷构造 info 字节串（utf-8）。 */
export function infoBytes(kind, resourceId = "") {
    return new TextEncoder().encode(INFO[kind] + resourceId);
}
